var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:chevron-left-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0666 14.2666L16.9333 20.3999C16.8 20.5333 16.6555 20.6275 16.5 20.6826C16.3444 20.7377 16.1778 20.7657 16 20.7666C15.8222 20.7666 15.6555 20.7386 15.5 20.6826C15.3444 20.6266 15.2 20.5324 15.0667 20.3999L8.93332 14.2666C8.68887 14.0222 8.56665 13.711 8.56665 13.3333C8.56665 12.9555 8.68887 12.6444 8.93332 12.3999C9.17776 12.1555 9.48887 12.0333 9.86665 12.0333C10.2444 12.0333 10.5555 12.1555 10.8 12.3999L16 17.5999L21.2 12.3999C21.4444 12.1555 21.7555 12.0333 22.1333 12.0333C22.5111 12.0333 22.8222 12.1555 23.0666 12.3999C23.3111 12.6444 23.4333 12.9555 23.4333 13.3333C23.4333 13.711 23.3111 14.0222 23.0666 14.2666Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.7b5c789ad397b1628a8a9c48ef8eaabd.svg";
export { ForwardRef as ReactComponent };